define('CustomMerchZone.Collection.View',
  [
    'SCCollectionView',
    'CustomMerchZone.Slide.View',
    'custom_merch_zone_collection_view.tpl'
  ],
  function (
    SCCollectionViewModule,
    CustomMerchZoneSlideView,
    Template
  ) {
    'use strict';

    var SCCollectionView = SCCollectionViewModule.SCCollectionView;

    function CustomMerchZoneCollectionView(options) {
      SCCollectionView.call(this, options.collection);

      this.collection = options.collection;

      this.template = Template;

      var self = this;

      this.collection.on('reset sync add remove change destroy', function () {
        self.render();
      });

    }

    CustomMerchZoneCollectionView.prototype = Object.create(SCCollectionView.prototype);
    CustomMerchZoneCollectionView.prototype.constructor = CustomMerchZoneCollectionView;

    CustomMerchZoneCollectionView.prototype.getCellViewsPerRow = function () {
      return 1;
    };

    CustomMerchZoneCollectionView.prototype.getCellViewInstance = function (model) {
      return new CustomMerchZoneSlideView({
        model: model
      });
    };

    CustomMerchZoneCollectionView.prototype.getEvents = function () {
      return {};
    };

    CustomMerchZoneCollectionView.prototype.getContext = function () {
      return {};
    };

    return 	CustomMerchZoneCollectionView;

  });
